import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useRevealStyles } from '../hooks/useRevealStyles';

// ============================================================================
// Component
// ============================================================================

export function ScheduleTourIntro() {
  useRevealStyles();
  const sectionRef = useScrollReveal<HTMLElement>();

  return (
    <section
      ref={sectionRef}
      className="reveal-fade-up w-full bg-[var(--vibe-color-background)] pt-[40px] pb-6 md:pb-9"
    >
      <div className="mx-auto px-3 sm:px-4 lg:px-6 text-center">
        <RichTextContent
          path="scheduletourintro.heading"
          label="Heading"
          defaultValue='<p>See <span data-type="field-token" data-field="property_name"></span> In Person</p>'
          as="h2"
          className="text-balance text-[clamp(2rem,8.8vw,3.5rem)] sm:text-[clamp(1rem,4.4vw,2.5rem)] uppercase tracking-wide leading-[1.1] mb-6"
          style={{ color: '#000', fontFamily: "'Poppins', sans-serif", fontWeight: 600 }}
        />

        <div className="max-w-3xl mx-auto md:px-10 lg:px-0">
          <RichTextContent
            path="scheduletourintro.body"
            label="Body Text"
            defaultValue={`<p>Ready to see <span data-type="field-token" data-field="property_name"></span> in person? Book a self-guided tour below when it works for you. Prefer a guided tour with a leasing agent? Those are by appointment only — use the contact form linked further down the page and an agent will follow up to schedule your visit.</p>`}
            as="div"
            className="font-body text-base leading-relaxed text-[var(--vibe-color-text-muted)] [&_p]:mb-4 [&_a]:text-primary [&_a]:underline"
          />
        </div>
      </div>
    </section>
  );
}

// ============================================================================
// Content Schema
// ============================================================================

export const contentSchema: ComponentContentSchema = {
  slot: 'ScheduleTourIntro',
  displayName: 'Schedule Tour Intro',
  tokens: {
    'scheduletourintro.heading': {
      label: 'Heading',
      type: 'richtext',
      defaultValue:
        '<p>See <span data-type="field-token" data-field="property_name"></span> In Person</p>',
    },
    'scheduletourintro.body': {
      label: 'Body Text',
      type: 'richtext',
      defaultField: 'property_scheduletour_blurb',
      defaultValue:
        '<p>Ready to see <span data-type="field-token" data-field="property_name"></span> in person? Book a self-guided tour below when it works for you. Prefer a guided tour with a leasing agent? Those are by appointment only — use the contact form linked further down the page and an agent will follow up to schedule your visit.</p>',
    },
  },
  slotGroups: {},
};

(ScheduleTourIntro as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default ScheduleTourIntro;
